import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography/index";
import React from "react";
import styled from "styled-components";
export var SingleShowroomVettingCriteria = function(param) {
    var icon = param.icon, vettingValue = param.vettingValue, vettingValueDescription = param.vettingValueDescription, color = param.color, titleTypographyVariants = param.titleTypographyVariants, alignText = param.alignText;
    if (vettingValueDescription) {
        return /*#__PURE__*/ _jsxs(Grid, {
            children: [
                /*#__PURE__*/ _jsx(IconWrapper, {
                    children: icon
                }),
                /*#__PURE__*/ _jsx(Title, {
                    color: color,
                    variant: titleTypographyVariants,
                    children: vettingValue
                }),
                /*#__PURE__*/ _jsx(Description, {
                    children: vettingValueDescription
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            icon,
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Title, {
                color: color,
                variant: titleTypographyVariants,
                $alignText: alignText,
                children: vettingValue
            })
        ]
    });
};
var Title = styled(Typography).withConfig({
    componentId: "sc-b5916bc1-0"
})([
    "grid-area:title;text-align:",
    ";"
], function(props) {
    var _props_$alignText;
    return (_props_$alignText = props.$alignText) !== null && _props_$alignText !== void 0 ? _props_$alignText : "left";
});
var Description = styled(Typography).attrs({
    color: Core.text.subdued
}).withConfig({
    componentId: "sc-b5916bc1-1"
})([
    "grid-area:description;text-align:left;"
]);
var IconWrapper = styled.div.withConfig({
    componentId: "sc-b5916bc1-2"
})([
    "grid-area:icon;display:flex;justify-self:center;"
]);
var Grid = styled.div.withConfig({
    componentId: "sc-b5916bc1-3"
})([
    'display:grid;align-items:center;justify-items:start;grid-template-columns:32px auto;grid-template-rows:auto;grid-template-areas:"icon title" ".    description";grid-gap:',
    ";"
], getSpacing("1x"));
